/* LLAMA Truck Owner's Manual page — behaviour (assets/llama-manual.js)
   The "models" section prints every model as JSON (#lhm-data). The hero dropdown,
   model cards, documents and specs modules all read that data and stay in sync. */
(function () {
  if (window.__lhmReady) return;
  window.__lhmReady = true;

  var ICON_DOC = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M6 3h8l4 4v14H6z"></path><path d="M14 3v4h4M9 12h6M9 16h6"></path></svg>';
  var ICON_DL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 4v11m0 0-4-4m4 4 4-4M5 20h14"></path></svg>';
  var state = { models: [], handle: '' };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }
  function safeUrl(url) {
    url = String(url || '').trim();
    return /^(https?:)?\/\//i.test(url) || url.charAt(0) === '/' ? url : '';
  }
  function current() {
    for (var i = 0; i < state.models.length; i++) {
      if (state.models[i].handle === state.handle) return state.models[i];
    }
    return null;
  }
  function parseSpecs(data) {
    var rows = [];
    function add(name, value) {
      name = String(name == null ? '' : name).trim();
      value = String(value == null ? '' : value).trim();
      if (name && value) rows.push([name, value]);
    }
    if (typeof data === 'string') {
      var text = data.trim();
      if (text.charAt(0) === '[' || text.charAt(0) === '{') {
        try { data = JSON.parse(text); } catch (e) {}
      }
    }
    if (Array.isArray(data)) {
      // [{ "name": "Payload", "value": "500 lb" }, ...]
      data.forEach(function (item) {
        if (item && typeof item === 'object') add(item.name, item.value);
      });
    } else if (data && typeof data === 'object') {
      // { "Payload": "500 lb", ... }
      Object.keys(data).forEach(function (key) { add(key, data[key]); });
    } else if (typeof data === 'string') {
      // plain text fallback: one "name | value" per line
      data.split(/\r?\n/).forEach(function (line) {
        var i = line.indexOf('|');
        if (i > -1) add(line.slice(0, i), line.slice(i + 1));
      });
    }
    return rows;
  }

  function loadData() {
    var node = $('#lhm-data');
    try { state.models = node ? JSON.parse(node.textContent) : []; } catch (e) { state.models = []; }
    if (!current()) state.handle = '';
  }

  function renderSelects() {
    $$('[data-lhm-select-input]').forEach(function (select) {
      select.textContent = '';
      var first = el('option', '', select.dataset.placeholder || '');
      first.value = '';
      select.appendChild(first);
      state.models.forEach(function (m) {
        var option = el('option', '', m.title);
        option.value = m.handle;
        select.appendChild(option);
      });
      select.value = state.handle;
    });
  }

  function renderCards() {
    $$('[data-lhm-card]').forEach(function (card) {
      var on = card.dataset.lhmCard === state.handle;
      card.classList.toggle('active', on);
      var pick = $('[data-lhm-select]', card);
      if (pick) pick.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function renderNames() {
    var m = current();
    $$('[data-lhm-name]').forEach(function (node) {
      node.textContent = m ? m.title : node.dataset.default;
    });
    $$('[data-lhm-title]').forEach(function (node) {
      node.textContent = node.dataset.template.replace('{model}', m ? m.title : node.dataset.fallback);
    });
  }

  function docRow(title, desc, url, download, soon) {
    var row = el('div', 'lhm-row');
    var icon = el('span', 'lhm-ic');
    icon.innerHTML = ICON_DOC;
    row.appendChild(icon);
    var text = el('div', 'lhm-row-text');
    text.appendChild(el('strong', '', title));
    if (desc) text.appendChild(el('span', '', desc));
    row.appendChild(text);
    var action;
    if (url) {
      action = el('a', 'btn2');
      action.href = url;
      action.target = '_blank';
      action.rel = 'noopener';
      action.innerHTML = ICON_DL;
      action.appendChild(document.createTextNode(download));
    } else {
      action = el('span', 'btn lhm-disabled', soon);
      action.setAttribute('aria-disabled', 'true');
    }
    row.appendChild(action);
    return row;
  }

  // Every document for a model: the JSON list if present, else owner's manual + quick start.
  function docsOf(m, d) {
    var list = [];
    if (Array.isArray(m.docs)) {
      m.docs.forEach(function (x) {
        var url = x && typeof x === 'object' ? safeUrl(x.url) : '';
        if (url) list.push({ title: String(x.title || d.manualTitle), desc: String(x.description || ''), url: url });
      });
    }
    if (list.length) return list;
    list.push({ title: d.manualTitle, desc: d.manualDesc, url: safeUrl(m.manual) });
    if (safeUrl(m.quick)) list.push({ title: d.quickTitle, desc: d.quickDesc, url: safeUrl(m.quick) });
    return list;
  }

  // Links that "Find my manual" can open directly.
  function linkedDocs(m) {
    var urls = [];
    if (Array.isArray(m.docs)) {
      m.docs.forEach(function (x) {
        var url = x && typeof x === 'object' ? safeUrl(x.url) : '';
        if (url) urls.push(url);
      });
    }
    if (urls.length) return urls;
    return safeUrl(m.manual) ? [safeUrl(m.manual)] : [];
  }

  function renderDownloads() {
    var m = current();
    $$('[data-lhm-downloads]').forEach(function (box) {
      var d = box.dataset;
      box.textContent = '';
      if (!m) { box.appendChild(el('div', 'lhm-empty', d.empty)); return; }
      var panel = el('div', 'lhm-panel');
      docsOf(m, d).forEach(function (doc) {
        panel.appendChild(docRow(doc.title, doc.desc, doc.url, d.btn, d.soon));
      });
      box.appendChild(panel);
    });
  }

  function renderSpecs() {
    var m = current();
    $$('[data-lhm-specs]').forEach(function (box) {
      box.textContent = '';
      if (!m) { box.appendChild(el('div', 'lhm-empty', box.dataset.empty)); return; }
      var rows = parseSpecs(m.specs);
      if (!rows.length) { box.appendChild(el('div', 'lhm-empty', box.dataset.none)); return; }
      var panel = el('div', 'lhm-panel');
      rows.forEach(function (r) {
        var line = el('div', 'lhm-spec');
        line.appendChild(el('span', '', r[0]));
        line.appendChild(el('span', '', r[1]));
        panel.appendChild(line);
      });
      box.appendChild(panel);
    });
  }

  function showError(on) {
    $$('[data-lhm-error]').forEach(function (node) { node.hidden = !on; });
    $$('[data-lhm-select-input]').forEach(function (select) {
      if (on) select.setAttribute('aria-invalid', 'true'); else select.removeAttribute('aria-invalid');
    });
  }

  function updateUrl() {
    try {
      var url = new URL(window.location.href);
      if (state.handle) url.searchParams.set('model', state.handle); else url.searchParams.delete('model');
      window.history.replaceState(null, '', url);
    } catch (e) {}
  }

  function renderAll() {
    renderSelects();
    renderCards();
    renderNames();
    renderDownloads();
    renderSpecs();
  }

  function select(handle) {
    state.handle = handle || '';
    if (!current()) state.handle = '';
    showError(false);
    renderAll();
    updateUrl();
  }

  function scrollTo(selector) {
    var node = $(selector);
    var target = node && (node.closest('section') || node);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-lhm-select-input]')) select(e.target.value);
  });

  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-lhm-select]');
    if (pick) {
      select(pick.dataset.lhmSelect);
      scrollTo('[data-lhm-downloads]');
      return;
    }
    if (e.target.closest('[data-lhm-find]')) {
      var m = current();
      if (!m) { showError(true); return; }
      var urls = linkedDocs(m);
      if (urls.length === 1) window.open(urls[0], '_blank', 'noopener');
      else scrollTo('[data-lhm-downloads]');
    }
  });

  function init() {
    loadData();
    var wanted = '';
    try { wanted = new URLSearchParams(window.location.search).get('model') || ''; } catch (e) {}
    if (!state.handle && wanted) state.handle = wanted;
    if (!current()) state.handle = '';
    renderAll();
  }

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();